"use client";

import React from "react";
import { Play } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const thumbnails = [{
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/waymo_expansion_phoenix.png",
  caption: "Waymo expanderar sina autonoma zoner i Phoenix och San Francisco."
}, {
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/robotaxi_business_case.png",
  caption: "Så beräknar du lönsamheten för en lokal Robotaxi-flotta."
}, {
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/tesla_fsd_v12_city.png",
  caption: "Imponerande framsteg med Tesla FSD v12 i komplex stadstrafik."
}];
const robotaxiVideos = [{
  id: "Qfj4urMF8CU",
  title: "Cybercab | Framtiden är autonom"
}, {
  id: "nmGOIbNoDZk",
  title: "Tesla 'We, Robot' Event - Sammanfattning"
}, {
  id: "wftOjQgleu0",
  title: "Robotaxi Business Case & Ekonomi"
}];
export default function ProgressInField() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="framsteg-i-fält" className="bg-background py-24 px-6" ref={ref}>
      <div className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-12 text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary mb-4">
            Framsteg i fält
          </h2>
          <p className="font-sans text-primary max-w-2xl mx-auto text-lg">
            Följ den senaste utvecklingen och se hur autonoma fordon redan idag
            förändrar transportsektorn i USA.
          </p>
        </div>

        {}
        <div className="mb-8 group cursor-pointer">
          <div className="rounded-[3px] overflow-hidden shadow-lg relative bg-muted">
            <AspectRatio ratio={16 / 9}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/us_robotaxi_progress_main.png" alt="Den snabba utvecklingen av autonoma fordon i USA" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
                <div className="bg-background/90 backdrop-blur-sm rounded-full p-5 shadow-xl transform transition-transform duration-300 group-hover:scale-110">
                  <Play className="w-12 h-12 text-primary fill-primary ml-1" />
                </div>
              </div>
            </AspectRatio>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {thumbnails.map((video, i) => <div key={i} data-index={i} className="flex flex-col gap-3 group cursor-pointer">
              <div className="rounded-[3px] overflow-hidden shadow-md relative bg-muted">
                <AspectRatio ratio={16 / 9}>
                  <img src={video.img} alt={video.caption} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors duration-300 flex items-center justify-center">
                    <div className="bg-background/90 backdrop-blur-sm rounded-full p-3 shadow-lg transform transition-transform duration-300 group-hover:scale-110">
                      <Play className="w-6 h-6 text-primary fill-primary ml-0.5" />
                    </div>
                  </div>
                </AspectRatio>
              </div>
              <p className="font-sans text-primary text-sm md:text-base leading-relaxed">
                {video.caption}
              </p>
            </div>)}
        </div>

        <div className="mt-20 mb-12 text-center">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-primary mb-4">
            Robotaxi Videosamling
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {robotaxiVideos.map((video, i) => <div key={video.id} data-index={i} className="flex flex-col gap-3 group cursor-pointer">
              <div className="rounded-[3px] overflow-hidden shadow-md relative bg-muted">
                <AspectRatio ratio={16 / 9}>
                  <iframe src={`https://www.youtube.com/embed/${video.id}`} title={video.title} className="w-full h-full border-0 transition-transform duration-500 group-hover:scale-105" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                </AspectRatio>
              </div>
              <p className="font-sans text-primary text-sm md:text-base leading-relaxed">
                {video.title}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}